/**
 * Protected Route Component
 * 
 * Wraps routes that require specific roles/permissions
 * 
 * Usage:
 * <ProtectedRoute requiredRole="admin">
 *   <AdminComponent />
 * </ProtectedRoute>
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { CircularProgress } from '@mui/material';

const ProtectedRoute = ({ children, requiredRole, requiredPermission }) => {
  const { role, hasPermission, loading } = useAuth();

  // Show loading state while fetching role
  if (loading) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <CircularProgress />
      </div>
    );
  }

  // Check role-based access
  if (requiredRole && role !== requiredRole) {
    return <Navigate to="/" replace />;
  }

  // Check permission-based access
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
